import axios from 'axios';
import { api } from '@/api';
import { app } from '@/main';

const types = {
    SET_TRANSACTIONS: 'SET_TRANSACTIONS',
    UPDATE_TRANSACTION: 'UPDATE_TRANSACTION',

    SET_TRANSACTIONS_REPORT: 'SET_TRANSACTIONS_REPORT',
    UPDATE_TRANSACTIONS_REPORT: 'UPDATE_TRANSACTIONS_REPORT',

    FETCH_FAILURE: 'FETCH_FAILURE',
    SET_LOADING_STATUS: 'SET_LOADING_STATUS',

    SET_SUBJECT: 'SET_SUBJECT',
    SET_SUBJECT_NAME: 'SET_SUBJECT_NAME',
    SET_TRANSACTION_TYPE: 'SET_TRANSACTION_TYPE',
    SET_DATE: 'SET_DATE',
    SET_SHIFT_TYPE: 'SET_SHIFT_TYPE',
    SET_SHIFT_ID: 'SET_SHIFT_ID',

    SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
    SET_ITEMS_PER_PAGE: 'SET_ITEMS_PER_PAGE',
    SET_TOTAL_ITEMS: 'SET_TOTAL_ITEMS',
}

export const state = {
    transactions: [],
    transactionsReport: {},

    loading: false,

    // filters
    subject: null,
    subjectName: null,
    transactionType: null,
    date: null,
    shiftType: null,
    shiftId: null,

    subjects: [
        'family',
        'babysitter'
    ],

    transactionTypes: [
        {
            id: 1,
            name: 'credit'
        },
        {
            id: 2,
            name: 'debit'
        }
    ],

    shiftTypes: [
        { id: 1, name: 'daily' },
        { id: 2, name: 'sleepover' },
        { id: 3, name: 'around the clock' },
        { id: 4, name: 'travel' },
    ],

    currentPage: 1,
    itemsPerPage: 10,
    total: null,
}

export const mutations = {
    [types.SET_TRANSACTIONS]( state: any, data: any ) {
        state.transactions = [];

        state.transactions.push(...data.data);
        state.total = data.meta.total ? data.meta.total : 1;
    },
    [types.SET_TRANSACTIONS_REPORT]( state: any, data: any ) {
        
        state.transactionsReport = { ...data };
        /* state.total = data.meta.total ? data.meta.total : 1; */
    },

    [types.SET_LOADING_STATUS]( state: any, bool: boolean ) {
        state.loading = bool;
    },

    [types.SET_SUBJECT]( state: any, data: string ) {
        state.subject = data;
    },
    [types.SET_SUBJECT_NAME]( state: any, data: string ) {
        state.subjectName = data;
    },
    [types.SET_TRANSACTION_TYPE]( state: any, data: object ) {
        state.transactionType = data;
    },
    [types.SET_DATE]( state: any, data: string ) {
        state.date = data;
    },
    [types.SET_SHIFT_TYPE]( state: any, data: any ) {
        state.shiftType = data;
    },
    [types.SET_SHIFT_ID]( state: any, data: string ) {
        state.shiftId = data;
    },

    [types.SET_CURRENT_PAGE]( state: any, data: number ) {
        state.currentPage = data;
    },

    [types.SET_ITEMS_PER_PAGE]( state: any, data: number ) {
        state.itemsPerPage = data;
    },
}

export const actions = { 
    async fetchTransactions({ commit, getters }: any, params: any) {
        try {
            commit(types.SET_LOADING_STATUS, true);
            let params = getters.payload;

            const { data } = await axios.get(api.path('v1.admin.transactions'), { params: params });

            commit(types.SET_TRANSACTIONS, data);
            commit(types.SET_LOADING_STATUS, false);
            
        } catch (e) {
            commit(types.FETCH_FAILURE);
            commit(types.SET_LOADING_STATUS, false);
        }
    },

    async fetchTransactionsReport({ commit, getters }: any, params: any) {
        try {
            commit(types.SET_LOADING_STATUS, true);
            let params = getters.payload; 

            const { data } = await axios.get(api.path('v1.admin.transactionsReport'), { params: params });
            
            commit(types.SET_TRANSACTIONS_REPORT, data);
            commit(types.SET_LOADING_STATUS, false);

        } catch (e) {
            commit(types.FETCH_FAILURE);
            commit(types.SET_LOADING_STATUS, false);
        }
    },

    clearPayload({ commit }: any, payload: any) {
        commit(types.SET_SUBJECT, null);
        commit(types.SET_SUBJECT_NAME, null);
        commit(types.SET_TRANSACTION_TYPE, null);
        commit(types.SET_DATE, null);
        commit(types.SET_SHIFT_TYPE, null);
        commit(types.SET_SHIFT_ID, null);

        commit(types.SET_CURRENT_PAGE, 1);
        commit(types.SET_ITEMS_PER_PAGE, 10);
    },

    setTransactions({ commit }: any, payload: any) {
        commit(types.SET_TRANSACTIONS, payload); 
    },
    setTransactionsLoading({ commit }: any, payload: any) {
        commit(types.SET_LOADING_STATUS, payload); 
    },

    setSubject({ commit }: any, payload: any) {
        commit(types.SET_SUBJECT, payload); 
    },
    setSubjectName({ commit }: any, payload: any) {
        commit(types.SET_SUBJECT_NAME, payload); 
    },
    setTransactionType({ commit }: any, payload: any) {
        commit(types.SET_TRANSACTION_TYPE, payload); 
    },
    setDate({ commit }: any, payload: any) {
        commit(types.SET_DATE, payload);
    },
    setShiftType({ commit }: any, payload: any) {
        commit(types.SET_SHIFT_TYPE, payload);
    },
    setShiftId({ commit }: any, payload: any) {
        commit(types.SET_SHIFT_ID, payload);
    },

    setCurrentPage({ commit }: any, payload: any) {
        commit(types.SET_CURRENT_PAGE, payload);
    },
    setItemsPerPage({ commit }: any, payload: any) {
        commit(types.SET_ITEMS_PER_PAGE, payload);
    },
}

export const getters = {
    transactions: ( state: any ) => state.transactions,
    transactionsReport: ( state: any ) => state.transactionsReport,

    transactionsLoading: ( state: any ) => state.loading,
    total: ( state: any ) => state.total,

    subject: ( state: any ) => state.subject,
    subjectName: ( state: any ) => state.subjectName,
    transactionType: ( state: any ) => state.transactionType,
    date: ( state: any ) => state.date,
    shiftType: ( state: any ) => state.shiftType,
    shiftId: ( state: any ) => state.shiftId,

    subjects: (state: any ) => state.subjects,
    transactionTypes: (state: any ) => state.transactionTypes,
    shiftTypes: (state: any ) => state.shiftTypes,

    currentPage: ( state: any ) => state.currentPage,
    itemsPerPage: ( state: any ) => state.itemsPerPage,

    payload: (state: any) => {
        return {
            subject: state.subject,
            subject_name: state.subjectName,
            type: state.transactionType,
            date: state.date,
            shift_type: state.shiftType,
            shift_id: state.shiftId,

            page: state.currentPage,
            per_page: state.itemsPerPage
        }
    }
}